"use client";

import { authClient } from "@repo/auth/client";
import { config } from "@repo/config";
import { Button } from "@ui/components/button";
import { useQueryState } from "nuqs";
import { parseAsString } from "nuqs";
import { oAuthProviders } from "../constants/oauth-providers";
import { useSearchParams } from "next/navigation";
export function SocialSigninButton({
  provider,
  className,
}: {
  provider: keyof typeof oAuthProviders;
  className?: string;
}) {
  const [invitationId] = useQueryState("invitationId", parseAsString);
  const providerData = oAuthProviders[provider];
  const searchParams = useSearchParams();
  const redirectTo = searchParams.get("redirectTo");
  console.log("redirectTo", redirectTo);
  const redirectPath = redirectTo ?? config.auth.redirectAfterSignIn;
  console.log("redirectPath", redirectPath);
  const onSignin = () => {
    const callbackURL = new URL(redirectPath, window.location.origin);
    console.log("redirectPath", redirectPath);
    console.log("window.location.origin", window.location.origin);
    console.log("callbackURL", callbackURL);
    // if (provider === "notion") {
    // 	authClient.signIn.oauth2({
    // 		providerId: "notion",
    // 		callbackURL: callbackURL.toString(),
    // 	});
    // } else {
    authClient.signIn.social({
      provider,
      callbackURL: callbackURL.toString(),
    });
    // }
  };

  return (
    <Button
      onClick={() => onSignin()}
      type="button"
      // variant="outline"
      className={className}
    >
      {providerData.icon && (
        <i className="mr-2 text-primary">
          <providerData.icon className="size-4" />
        </i>
      )}
      {providerData.name}
    </Button>
  );
}
